import {
    Modal,
    Autocomplete,
    ICodename
} from "@maysoft/common-component-react"
import {
    Stack,
    Paper,
    Grid,
    Typography,

} from "@mui/material"
import { useEffect, useState } from "react"
import EmailConfigForm from "../container/emailConfig"
import FirebaseConfigForm from "../container/firebaseConfig"
import TelegramConfigForm from "../container/telegramConfig"
import TemplateConfigForm from "../container/casecodeConfig"
import SimpleSettingForm from "../container/simpleConfig"
import Constants from "../../../constants";
import Strings from "constants/strings"
import { ISystemSetting } from "services/message/systemSetting.service"
import NotificationConfigForm from "../container/postNotification"

const SETTING_FORM_MAP: Record<string, any> = {
    [Constants.SettingCode.EMAIL_CONFIG]: EmailConfigForm,
    [Constants.SettingCode.FIREBASE_CONFIG]: FirebaseConfigForm,
    [Constants.SettingCode.TELEGRAM_CONFIG]: TelegramConfigForm,
    [Constants.SettingCode.CASE_CODE]: TemplateConfigForm,
    [Constants.SettingCode.POST_NOTIFICATION]: NotificationConfigForm
}

const SETTING_OPTIONS: ICodename[] = [
    { name: "Email Config", code: Constants.SettingCode.EMAIL_CONFIG },
    { name: "Firebase Config", code: Constants.SettingCode.FIREBASE_CONFIG },
    { name: "Telegram Config", code: Constants.SettingCode.TELEGRAM_CONFIG },
    { name: "Template Config", code: Constants.SettingCode.CASE_CODE },
    { name: "Post Notification Config", code: Constants.SettingCode.POST_NOTIFICATION },
    { name: "Online Time Terminate", code: Constants.SettingCode.ONLINE_TIME_TERMINATE },
    { name: "Schedule Job Fetch Time", code: Constants.SettingCode.SCHEDULE_JOB_FETCH_TIME }
]

const DEFAULT_VALUE_MAP: Record<string, any> = {
    [Constants.SettingCode.EMAIL_CONFIG]: {
        MailAddress: "",
        Credential: "",
        Host: "",
        Port: "",
        EnableSsl: false,
        SenderName: ""
    },
    [Constants.SettingCode.TELEGRAM_CONFIG]: {
        BotToken: "",
        BotUserName: "",
        HostAddress: "",
        DefaultChatId: ""
    },
    [Constants.SettingCode.FIREBASE_CONFIG]: {
        vapidKey: "",
        adminSDK: {
            type: "service_account",
            project_id: "",
            private_key_id: "",
            private_key: "",
            client_email: "",
            client_id: "",
            auth_uri: "",
            token_uri: "",
            auth_provider_x509_cert_url: "",
            client_x509_cert_url: "",
            universe_domain: "googleapis.com"
        },
        clientConfig: {
            apiKey: "",
            authDomain: "",
            projectId: "",
            storageBucket: "",
            messagingSenderId: "",
            appId: "",
            measurementId: ""
        }
    },
    [Constants.SettingCode.CASE_CODE]: {
        notification: [],
        email: [],
        sms: []
    },
    [Constants.SettingCode.SCHEDULE_JOB_FETCH_TIME]: "",
    [Constants.SettingCode.ONLINE_TIME_TERMINATE]: ""
}

type Props = {
    tenants: ICodename[]
    services: ICodename[]
    visibled: boolean
    onClose: () => void
    onSubmit: (data: ISystemSetting) => void
}

const CreateSettingModal = ({
    tenants,
    services,
    visibled,
    onClose,
    onSubmit
}: Props) => {

    const [settingCode, setSettingCode] = useState<string>(null)
    const [tenantCode, setTenantCode] = useState<string>(null)
    const [serviceCode, setServiceCode] = useState<string>(null)
    const [data, setData] = useState<any>("")

    // 👉 reset data khi đổi type
    useEffect(() => {
        setData(DEFAULT_VALUE_MAP[settingCode] || "")
    }, [settingCode])

    const Form =
        SETTING_FORM_MAP[settingCode] ||
        SimpleSettingForm

    const handleSubmit = () => {
        const value =
            typeof data === "string"
                ? data
                : JSON.stringify(data)

        onSubmit({
            settingCode,
            settingValue: value,
            serviceCode,
            tenantCode,
            organizationId: "0"
        })
    }

    return (
        <Modal
            visible={visibled}
            // maxWidth="md"
            // fullWidth
            fullScreen
            title="Create Setting"
            buttonAction={Strings.Common.SAVE}
            onClose={onClose}
            onAction={handleSubmit}
            hasActionButton
        >
            <Stack spacing={3}>
                <Paper sx={{ p: 2, borderRadius: 2 }}>
                    <Typography variant="h5" mb={2}>{Strings.SETTING.BASIC}</Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Autocomplete
                                data={services}
                                label={Strings.SETTING.SERVICE}
                                placeholder={Strings.SETTING.SELECT_SERVICE}
                                defaultValue={serviceCode || ""}
                                onChange={(value) => { setServiceCode(value) }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Autocomplete
                                data={tenants}
                                label={Strings.SETTING.TENANT}
                                placeholder={Strings.SETTING.SELECT_TENANT}
                                defaultValue={tenantCode || ""}
                                onChange={(value) => { setTenantCode(value) }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Autocomplete
                                label={Strings.SETTING.CODE}
                                defaultValue={settingCode ?? ""}
                                data={SETTING_OPTIONS || []}
                                onChange={setSettingCode}
                            />
                        </Grid>
                    </Grid>

                </Paper>

                {/* FORM */}
                {settingCode && (
                    <Paper sx={{ p: 2, borderRadius: 2 }}>
                        <Typography variant="h5" mb={2}>{Strings.SETTING.DETAIL}</Typography>
                        <Form
                            value={data}
                            onChange={setData}
                        />
                    </Paper>
                )}
            </Stack>
        </Modal>
    )
}

export default CreateSettingModal